import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from "app/globals";

import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';

@Injectable()
export class ClientsService {

    url: string = `${this._Globals.serviceUrl}ELIClientsService.svc/`;

    constructor(
        private httpClient: HttpClient,
        public _Globals: Globals,
        public _CryptoJs: CryptoJs
    ) { }

    public getAssessmentSectionQuestions(assessmentId: number, sectionId: number): Observable<any> {

        let url = `${this.url}GetAssessmentSectionQuestions?assessmentId=${assessmentId}&sectionId=${sectionId}&language=en`;

        return this.httpClient.get(url);

    }

    public getAssessmentSections(id: number): Observable<any> {

        let url = `${this.url}GetAssessmentSections?id=${id}`;

        return this.httpClient.get(url);

    }

    getAssignedAssessment(assignedAssessmentId: number, userType: number) {

          let url = `${this.url}GetAssignedAssessment?assignedAssessmentId=${assignedAssessmentId}&userId=${this._Globals.getUserId()}&userType=${userType}`;
        //let url = `http://localhost:54541/ELIClientsService.svc/GetAssignedAssessment?assignedAssessmentId=${assignedAssessmentId}&userId=${this._Globals.getUserId()}&userType=${userType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });

    }

    private generateRandomString(length: number): string {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters.charAt(randomIndex);
        }

        return result;
    }


    getClientCompletedAssessments() {

        let url = `${this.url}JH78U`;

        let json: any = JSON.stringify(
            { nthig: this._Globals.getUserId() }
        );
        json = json.replace(/\\\"/g, '\"');

        let e = this._CryptoJs.encrypt(json, this._Globals.lpassString);

        let data = 
        {
            nthig9: e,
            bvt7: this.generateRandomString(15)
        };

        let body = JSON.stringify(data);

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.post(url, body, { headers: headers });

    }

    getClientPendingAssessments() {

        let url = `${this.url}GetClientPendingAssessments?clientId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    public getQuestionChoices(questionId: number, language: string): Observable<any> {

        let url = `${this.url}GetQuestionChoices?questionId=${questionId}&language=${language}`;

        return this.httpClient.get(url);

    }

    getRaters(asignmentId: number) {

        let url = `${this.url}GetRaters?clientId=${this._Globals.getUserId()}&asignmentId=${asignmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    getRaterTypes() {

        let url = `${this.url}GetRaterTypes`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //{"input":{"AssignmentId":[ASSIGNMENT ID],"UserId":[USER ID],"UserType":[USER TYPE]}}
    public postProcessAssessment(processAssessmentDto: ProcessAssessmentDto): Observable<any> {

        let url = `${this.url}ProcessAssessment`;
         //let url = `http://localhost:54541/ELIClientsService.svc/ProcessAssessment`;

        let processAssessmentBody: any = {
            "input": {
                "AssignmentId": processAssessmentDto.assignmentId,
                "UserId": this._Globals.getUserId(),
                "UserType": processAssessmentDto.userType
            }
        };

        let body = JSON.stringify(processAssessmentBody);
        console.log('body processAssessment: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'//,
            // 'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"input":{"Answer":{"ClientId":3,"AssignedAssessmentId":3,"SectionId":1,"QuestionId":3,"Answer":1}}}
    //{"input":{"ClientId":3,"AssignedAssessmentId":"4","SectionId":1,"QuestionId":3,"Answer":"33"}}
    postSaveAssessmentAnswer(input: SaveQuestionDto) {

        let url = `${this.url}SaveAssessmentAnswer`;

        let postSaveAssessmentAnswer: any = {
            "input": {
                "Answer": {
                    "ClientId": this._Globals.getUserId(),
                    "AssignedAssessmentId": input.AssignedAssessmentId,
                    "SectionId": input.SectionId,
                    "QuestionId": input.QuestionId,
                    "Answer": input.Answer
                }
            }
        };

        let body = JSON.stringify(postSaveAssessmentAnswer);
        console.log('body postSaveAssessmentAnswer: ' + body);

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
            //.set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.post(url, body, { headers: headers });
    }

    postSaveAssessmentAnswerForTest(input: SaveQuestionDto) {

        let url = `${this.url}SaveAssessmentAnswerForTest`;

        let postSaveAssessmentAnswer: any = {
            "input": {
                "Answer": {
                    "ClientId": this._Globals.getUserId(),
                    "AssignedAssessmentId": input.AssignedAssessmentId,
                    "SectionId": input.SectionId,
                    "QuestionId": input.QuestionId,
                    "Answer": input.Answer
                }
            }
        };

        let body = JSON.stringify(postSaveAssessmentAnswer);
        console.log('body postSaveAssessmentAnswer: ' + body);

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        //.set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.post(url, body, { headers: headers });
    }

    /*{"input":
     {
        "ClientId": [CLIENT ID], 
        "AssignmentId": [ASSIGNMENT ID], 
        "AssignedBy": [ASSIGNED BY], 
        "ExpiresIn": [EXPIRES IN], 
        "ScheduledFor": [SCHEDULED FOR], 
        "Language": [LANGUAGE], 
        "SendEmailInvitationNow": [SEND EMAIL INVITATION NOW], 
        "TimeOffset": [TIMEOFFSET], 
        "Raters": 
        [{ 
            "RaterId": [RATER ID], 
            "Email": [RATER EMAIL], 
            "FirstName": [RATER FIRST NAME], 
            "LastName": [RATER LAST NAME], 
            "RaterType": [RATER TYPE ID], 
            "RecordStatus": [RATER STATUS] 
        }]
    }}
    */

    public postSaveRaters(rater: RaterDto): Observable<any> {

        let url = `${this.url}SaveRaters`;

        let saveRater: any = {
            "input": {
                "ClientId": parseInt(rater.ClientId),
                "AssignmentId": rater.AsignmentId,
                "AssignedBy": this._Globals.getUserId(),
                "ExpiresIn": rater.ExpiresIn,
                "ScheduledFor": rater.ScheduledFor,
                "Language": rater.Language,
                "SendEmailInvitationNow": rater.SendEmailInvitationNow,
                "TimeOffSet": rater.TimeOffSet,
                "Raters": rater.Raters
            }

        }

        let body = JSON.stringify(saveRater);
        console.log('body postSaveRater: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getCompletedAssessmentDetails(assignmentId: number): Observable<any> {
        let url = `${this.url}GetCompletedAssessmentDetails?assignmentId=${assignmentId}`;

        return this.httpClient.get(url);
    }

    public getAssessmentSectionChoices(choiceSetId: number, language:string): Observable<any> {
        let url = `${this.url}GetAssessmentSectionChoices?choiceSetId=${choiceSetId}&language=${language}`;

        return this.httpClient.get(url);
    }

    //{"user":{"Email":"johann.granados@softcial.com","FirstName":"Johann","LastName":"Granados","Password":"123456"}}
    public postActivateUserAccount(user: ActivateUserAccountDto, userType: number): Observable<any> {

        let url = `${this.url}ActivateClientAccount`;
        //let url = `http://localhost:54541/ELIClientsService.svc/ActivateClientAccount`;

        let body: any = {
            "user": {
                "Email": user.Email,
                "FirstName": user.FirstName,
                "LastName": user.LastName,
                "Password": user.Password
            }
        };

        body = JSON.stringify(body);
        console.log('body activateUserAccount: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        //let url;
        //switch (userType) {
        //    case 1: {
        //        url = this.clientUrl;
        //        break;
        //    }
        //    case 2: {
        //        url = this.raterUrl;
        //        break;
        //    }
        //}

        return this.httpClient.post(url, body, { headers });
    }

    //{"email":[EMAIL ADDRESS]"}
    public postForgotPassword(email: string): Observable<any> {

        let url = `${this.url}ForgotPassword`;
        //let url = `http://localhost:54541/ELIClientsService.svc/ForgotPassword`;

        let body: any = {
            email: email
        }

        body = JSON.stringify(body);
        console.log('ForgotPassword body: ', body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': ''
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{ "input": { "Id": [USER ID], "Email": "[EMAIL]", "FirstName": "[FIRST NAME]", "LastName": "[LAST NAME]" } }
    public postUpdateClient(clientProfile: ClientProfileDto): Observable<any> {
        let url = `${this.url}UpdateClient`;

        let body: any = {
            "input": {
                "Id": this._Globals.getUserId(),
                "Email": clientProfile.Email,
                "FirstName": clientProfile.FirstName,
                "LastName": clientProfile.LastName
            }
        };

        body = JSON.stringify(body);
        console.log('UpdateClient body: ', body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //GetClientAssignedAssessmentsByType?coachId=[COACH ID]&clientId=[CLIENT ID]&assessmentType=[ASSESSMENT TYPE]
    getClientAssignedAssessmentsByType(clientId: number, assessmentType: number) {

        let url = `${this.url}GetClientAssignedAssessmentsByType?coachId=${this._Globals.getUserId()}&clientId=${clientId}&assessmentType=${assessmentType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //GetClientCompletedAssessmentsByType?coachId=[COACH ID]&clientId=[CLIENT ID]&assessmentType=[ASSESSMENT TYPE]
    getClientCompletedAssessmentsByType(clientId: number, assessmentType: number) {

        let url = `${this.url}GetClientCompletedAssessmentsByType?coachId=${this._Globals.getUserId()}&clientId=${clientId}&assessmentType=${assessmentType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    //GetClienExpiredAssessmentsByType?coachId=[COACH ID]&clientId=[CLIENT ID]&assessmentType=[ASSESSMENT TYPE]
    getClientExpiredAssessmentsByType(clientId: number, assessmentType: number) {
        let url = `${this.url}GetClientExpiredAssessmentsByType?coachId=${this._Globals.getUserId()}&clientId=${clientId}&assessmentType=${assessmentType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public getUserInfo(userId: number): Observable<any> {
        let url = `${this.url}GetUserInfo?userId=${userId}`;

        return this.httpClient.get(url);
    }

    getUserSecurityAnswers(userId: number) {
        let url = `${this.url}GetUserSecurityAnswers?userId=${userId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postUpdatePassword(email: string, password: string): Observable<any> {

        let url = `${this.url}UpdatePassword`;
        //let url = `http://localhost:54541/ELIClientsService.svc/UpdatePassword`;

        let body: any = {
            "email": email,
            "password": password
        };

        body = JSON.stringify(body);
        console.log('body activateUserAccount: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{"input":{
    //"UserId": [CURRENT USER ID], 
    //"Answers": [{ "SecurityQuestionId": [QUESTION ID], "Answer": "[QUESTION ANSWER]" }, { "SecurityQuestionId": [QUESTION ID], "Answer": "[QUESTION ANSWER]" }]
    //}}

    public postUpdateSecurityAnswers(userId: number, answers: any[]): Observable<any> {
        let url = `${this.url}UpdateSecurityAnswers`;

        let body: any = {
            "input":{
                "UserId": userId,
                "Answers": answers
            }
        }

        body = JSON.stringify(body);
        console.log('postUpdateSecurityAnswers body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //{ "userId": [USER ID], "currentPassword": "[ENCRYTED CURRENT PASSWORD", "password": "[ENCRYPTED NEW PASSWORD]" }
    public postUpdatePasswordFromProfile(currentPassword: string, password: string, userId: number): Observable<any> {
        let url = `${this.url}UpdatePasswordFromProfile`;

        let body: any = {
            "userId": userId,
            "currentPassword": currentPassword,
            "password": password
        };

        body = JSON.stringify(body);
        console.log('body activateUserAccount: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    getClientArchivedAssessments(clientId: number, assessmentType: number) {

        let url = `${this.url}MB76?ct6=${this._Globals.getUserId()}&lo2=${clientId}&ky8=${assessmentType}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    getClientDiscount() {

        let url = `${this.url}KU67?kl9=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postSaveFreeEntryAnswer(questionChoiceId: number, assignmentId: number, answer: string): Observable<any> {
        let url = `${this.url}SaveFreeEntryAnswer`;

        let body: any = {
            questionChoiceId,
            assignmentId,
            clientId: this._Globals.getUserId(),
            entry: answer
        };

        body = JSON.stringify(body);
        console.log('body SaveFreeEntryAnswer: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public postRemoveFreeEntryAnswer(questionChoiceId: number, assignmentId: number) {
        let url = `${this.url}RemoveFreeEntryAnswer`;

        let body: any = {
            questionChoiceId,
            assignmentId,
            clientId: this._Globals.getUserId()
        };

        body = JSON.stringify(body);
        console.log('body RemoveFreeEntryAnswer: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public getFreeEntryAnswer(questionChoiceId: number, assignmentId: number) {

        let url = `${this.url}GetFreeEntryAnswer?questionChoiceId=${questionChoiceId}&assignmentId=${assignmentId}&clientId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public resetPasswordCodeIsValid(userId: number, code: string): Observable<any> {
        let url = `${this.url}ResetPasswordCodeIsValid?userId=${userId}&code=${code}`;
        //let url = `http://localhost:54541/ELIClientsService.svc/ResetPasswordCodeIsValid?userId=${userId}&code=${code}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());

        return this.httpClient.get(url, { headers: headers });
    }

    public postRedeemPasswordCode(code: string): Observable<any> {
        let url = `${this.url}RedeemPasswordCode?code=${code}`;
        //let url = `http://localhost:54541/ELIClientsService.svc/RedeemPasswordCode?code=${code}`;

        const body = {
            code
        };
        console.log('body postRedeemPasswordCode: ' + body);

        let headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.httpClient.post(url, body, { headers: headers });
    }
}

export class ClientProfileDto {
    Email: string;
    FirstName: string;
    LastName: string;
}

export class ActivateUserAccountDto {
    Email: string;
    FirstName: string;
    LastName: string;
    Password: string;
}

export class ProcessAssessmentDto {
    assignmentId: number;
    userType: number;
}

export class SaveQuestionDto {
    ClientId: number;
    AssignedAssessmentId: number;
    SectionId: number;
    QuestionId: number;
    Answer: number;
}


export class RaterDto {
    ClientId: any;
    AsignmentId: number;
    AssignedBy: number;
    ExpiresIn: number;
    ScheduledFor: string;
    Language: string;
    SendEmailInvitationNow: boolean;
    TimeOffSet: number;
    Raters: RaterDtoRaters[];
}

export class RaterDtoRaters {
    RaterId: number;
    Email: string;
    FirstName: string;
    LastName: string;
    RaterType: number;
    RecordStatus: number
}